import Axios from "axios"
import { apiHost } from '../config/routes'
const mode = process.env.VUE_APP_COMPLIANCE_MODE
// const appId = '4b227777d4dd1fc61c6f884f48641d02b4d121d3fd328cb08b5531fcacdabf8a';

const handleResponse = (response) => {
  const responseObj = {
    status: 500,
    error: null,
    data: null,
    success: false
  };

  if (response && response.status) {
    responseObj.status = response.status;
  } else if (response && response.response) {
    responseObj.status = response.response.status;
  }
  responseObj.success =
    responseObj.status === 200 || responseObj.status === 201;

  if (responseObj.status !== 200 && responseObj.status !== 201) {
    if (response) {
      if (response.response) responseObj.error = response.response.error;
      if (response.message) responseObj.error = response.message;
      if (response.response?.data) responseObj.error = response.response.data.message
    }
    if (typeof responseObj.error !== 'string' || !responseObj.error.trim()) {
      responseObj.error = 'Ha ocurrido un error no controlado, por favor intenta de nuevo.';
    }
  }

  responseObj.data =
    responseObj.status === 200 || responseObj.status === 201
      ? response.data?.data || response.data || response.result
      : null;

  return responseObj;
}

Axios.interceptors.request.use((config) => {
        if (!config.headers) config.headers = {}
        if(!(config && config.headers && typeof config.headers.appid === 'string' && config.headers.appid.trim() !== '')){
            config.headers.appid = '4b227777d4dd1fc61c6f884f48641d02b4d121d3fd328cb08b5531fcacdabf8a'
        } 
        return config
    });

const addAppIdToHeaders = (headers = {}) => {
  if (headers.hasOwnProperty('appId')) {
    // If appId is already in headers, return headers as is
    return headers; 
  }
  return {
    ...headers,
    // appId: appId
  };
};

export const post = async (resource, data, headers) => {
  headers = addAppIdToHeaders(headers);
  return Axios.post(`${apiHost}/${resource}`, data, { headers })
    .then(handleResponse)
    .catch(handleResponse);
};

export const get = async (resource, params, headers) => {
  headers = addAppIdToHeaders(headers);
  return Axios.get(`${apiHost}/${resource}`, { headers, params })
    .then(handleResponse)
    .catch(handleResponse);
};

export const getProfile = async (resource, headers = {}) => {
  headers = addAppIdToHeaders(headers);
  return Axios.get(`${apiHost}/${resource}`, { headers })
    .then(handleResponse)
    .catch(handleResponse);
};

export const put = async (resource, data, headers) => {
  headers = addAppIdToHeaders(headers);
  return Axios.put(`${apiHost}/${resource}`, data, { headers })
    .then(handleResponse)
    .catch(handleResponse);
};

export const compliance = async (data) => {
  const options = {
    // headers: {
    //   accesstoken: mode === 'test' ? process.env.VUE_APP_COMPLIANCE_TOKEN_TEST : process.env.VUE_APP_COMPLIANCE_TOKEN_PROD
    // }
  };
  const url = mode === 'test' ? `${apiHost}/compliancetest` : `${apiHost}/compliance`;
  options.headers = addAppIdToHeaders(options.headers); // Add appId to headers
  return Axios.post(url, data, options)
    .then(handleResponse)
    .catch(handleResponse);
};

export const complianceService = async (data)=> {
  const options = {
    headers: {
      "AccessToken": "WSFALKONJY68PZUYWZXX"
    }
  };
  const url = mode === 'test' ? `${apiHost}/service-compliancetest` : `${apiHost}/service-compliance`;
  options.headers = addAppIdToHeaders(options.headers); // Add appId to headers
  return Axios.post(url, data, options)
    .then(handleResponse)
    .catch(handleResponse);
}